import {
  channelObjects,
  parseUrlChannel,
} from '../../../shared/model/constants/channels';
import { getUrlForChannel } from '../../../shared/model/constants/opengraphImage';
import { parseConfig } from '../../../shared/config';

const { ForSale, ForLease, Leased, Sold, Invest } = channelObjects;

export const metaDescriptionMap = new WeakMap();
metaDescriptionMap.set(ForSale, 'Browse Commercial Real Estate for sale and for lease on Australia’s No.1 Commercial Property site. Find the latest commercial properties & real estate market data.');
metaDescriptionMap.set(ForLease, 'Find commercial properties for lease across Australia. Search the latest commercial rental property listings to find offices, warehouses and shops for rent.');
metaDescriptionMap.set(Sold, "Browse sold commercial real estate to find out the details of sold commercial properties on Australia's No.1 commercial property site.");
metaDescriptionMap.set(Leased, "Browse leased commercial real estate to find out the details of leased commercial properties on Australia's No.1 commercial property site.");
metaDescriptionMap.set(Invest, 'Investing in commercial property with realcommercial.com.au. Explore Australian commercial investment property prices, tenancy, net income & yield.');

const headingMap = new WeakMap();
headingMap.set(ForSale, 'Commercial property for sale');
headingMap.set(ForLease, 'Commercial property for lease');
headingMap.set(Sold, 'Sold commercial property history');
headingMap.set(Leased, 'Leased commercial property history');
headingMap.set(Invest, 'Commercial property investments');

export function getHeadingForChannel(channelObject) {
  return headingMap.get(channelObject);
}

export default function metaData(
  data,
  pathname,
  hostname,
  query,
) {
  const websiteRoot = parseConfig().WEBSITE_ROOT;
  const canonicalUrl = `${websiteRoot}/`;
  const channelString = query.channel || ForSale.url;
  const channelObject = parseUrlChannel(channelString);
  const description = metaDescriptionMap.get(channelObject);
  const opengraphImage = getUrlForChannel(channelObject);

  const link = [
    {
      rel: 'canonical',
      href: canonicalUrl,
    },
  ];

  return {
    title: channelObject.title,
    meta: [
      {
        name: 'description',
        content: description,
      },
      {
        property: 'og:image',
        content: opengraphImage,
      },
      {
        property: 'og:description',
        content: description,
      },
      {
        property: 'og:url',
        content: canonicalUrl,
      },
    ],
    link,
  };
}
